import "../styles/About.css";

function Nosotros() {
  return (
    <main className="df wp rw jcc aic about">
      <section className="main d-df d-rw d-wp d-jcb d-ais">
        <h1>Nosotros</h1>
        <article className="article">
          <p>
            Nuestra empresa fue fundada hace más de 20 años, como un
            desprendimiento de una líder y tradicional del mercado de envases.
          </p>
          <p>
            Para la producción de los mismos, contamos con 3 líneas productivas
            con máquinas impresoras a 6 colores + barniz, troqueladoras
            automáticas con tercera estación, pegadoras de estuches, equipos
            complementarios y un equipo de profesionales altamente capacitados,
            sustentado mediante un sistema de mejora continua basado en la Norma
            ISO 9001:2015
          </p>
          <p>
            Estamos instalados en una planta con más de 2500 m2 de superficie en
            la localidad de San Martín, Provincia de Buenos Aires.
          </p>
        </article>
      </section>
      <section className="df rw wp jcc aic d-df d-wp d-rw d-jcc d-aist">
        <article className="df wp rw jcc aic box">
          <h2>MISIÓN</h2>
          <p>
            Buscar la mayor integración con nuestros clientes, para que ellos
            logren la mejor presentación de sus productos, en sus mercados
            nacionales e internacionales, dando la mejor respuesta a sus
            necesidades.
          </p>
        </article>
        <article className="df wp rw jcc aic box">
          <h2>VISIÓN</h2>
          <p>
            Ser una empresa líder en el mercado manteniendo nuestra calidad en
            el servicio de impresos gráficos, ofreciendo nuestros servicios a
            través de un proceso de mejora continua.
          </p>
        </article>
      </section>
    </main>
  );
}

export default Nosotros;
